<template>
  <div class="content">
    <div class="bg">
      <div class="info">
        <div class="left">
          <p class="status">{{status}}</p>
          <p class="title">
            {{title}}
          </p>
          <div class="details">
            <div class="detail">
              <div class="detailLeft">
                <span class="detailTitle">所属部门</span>
                <span>{{dep}}</span>
              </div>
              <div class="detailRight" v-if="showTopic">
                <span class="detailTitle">{{`所属${$_syscfg.topic}`}}</span>
                <a href="#" @click.prevent="goTopic(topicId)">{{topic}}</a>
              </div>
            </div>
            <div class="detail">
              <div class="detailLeft">
                <span class="detailTitle">{{`${$_syscfg.interview}时间`}}</span>
                <span>{{`${startTime}   ~   ${endTime}`}}</span>
              </div>
              <div class="detailRight">
                <span class="detailTitle">{{`${$_syscfg.interview}地点`}}</span>
                <span>{{locate}}</span>
              </div>
            </div>
          </div>
          <div class="requires">
            <p class="requireItem">
              {{`${$_syscfg.interview}需求`}}
            </p>
            <div class="requireItem">
              <div class="requireLeft">
                <img src="@assets/img/interview/reporter.svg" alt="记者">
                <span class="requireKey">记者</span>
                <span class="requireValue">
                  <span :class="{card: r.id != 0}" v-for="(r, i) in reporter" :key="i" @click="showCard(r.id, 0, $event)">
                    {{r.name}}{{i===reporter.length-1?'':','}}
                  </span>
                </span>
              </div>
              <div class="requireRight">
                <img src="@assets/img/interview/camera.svg" alt="摄像">
                <span class="requireKey">摄像</span>
                <span class="requireValue">
                  <span :class="{card: r.id != 0}" v-for="(r, i) in camera" :key="i" @click="showCard(r.id, 1, $event)">
                    {{r.name}}{{i===camera.length-1?'':','}}
                  </span>
                </span>
              </div>
            </div>
            <div class="requireItem">
              <div class="requireLeft">
                <img src="@assets/img/interview/driver.svg" alt="司机">
                <span class="requireKey">司机</span>
                <span class="requireValue">
                  <span :class="{card: r.id != 0}" v-for="(r, i) in driver" :key="i" @click="showCard(r.id, 1, $event)">
                    {{r.name}}{{i===driver.length-1?'':','}}
                  </span>
                </span>
              </div>
              <div class="requireRight">
                <img src="@assets/img/interview/bus.svg" alt="采访车">
                <span class="requireKey">采访车</span>
                <span class="requireValue">{{bus}}</span>
              </div>
            </div>
          </div>
          <div class="msg">
            <p class="msgTitle">备注</p>
            <div class="msgContent">
              {{remark || '无'}}
            </div>
          </div>
        </div>
        <div class="right">
          <div class="people">
            <div class="block">
              <p class="key">
                发布者
              </p>
              <p :class="{value: true, none: !publisher, card: publisher}" @click="showCard(publisherId, 0, $event)">
                {{publisher || '无'}}
              </p>
            </div>
            <div class="seperator"></div>
            <div class="block">
              <p class="key">
                审批人
              </p>
              <p :class="{value: true, none: !approver, card: approver}" @click="showCard(approverId, 0, $event)">
                {{approver || '无'}}
              </p>
            </div>
            <div class="seperator"></div>
            <div class="block">
              <p class="key">
                调度人
              </p>
              <div>
                <p v-if="handler" :class="{value: true, none: !handler, card: handler, c: true}" @click="showCard(handlerId, 0, $event)">
                  {{handler || '无'}}
                </p>
                <p v-if="expandhandler" :class="{value: true, none: !expandhandler, card: expandhandler, c: true}" @click="showCard(expandhandlerId, 0, $event)">
                  {{expandhandler || '无'}}
                </p>
                <p v-if="!handler && !expandhandler" :class="{value: true, none: true}">
                  无
                </p>
              </div>
            </div>
          </div>
          <div class="equipment">
            <div class="title">
              <div class="l">拓展类设备</div>
              <div v-show="is_received == 0" class="r">待领取</div>
              <div v-show="is_received == 1" class="g">已领取</div>
            </div>
            <div v-if="expand_device_task_status == 5" class="list backStatus-container">
              <div class="icon"></div>
              <span>设备申请被退回</span>
              <p v-if="back_reason">退回理由：{{ back_reason }}</p>
            </div>
            <div v-else :class="{list: true, empty: equipments.length == 0}">
              <empty :msg="'暂无资源'" v-if="equipments.length == 0" />
              <div v-if="statusNum == '0' || statusNum == '1' || (statusNum == '2' && expandDevice.length == 0) || (statusNum == '5' && expandDevice.length == 0)" class="content">
                <div class="item" v-for="(i, d) in equipments" :key="d">
                  <div class="item-left">{{i.rc_name}}</div>
                  <div class="item-right">
                    <p class="num">申请：{{i.num}}</p>
                  </div>
                </div>
              </div>
              <div class="content">
                <div @mouseleave="tipsout" @click="equipDetail(i)" class="item" v-for="(i, d) in expandDevice" :key="d">
                  <div v-if="(i.popup.return_verify_name || i.popup.return_verify_time || i.popup.return_verify_remark || i.popup.delay_verify_name || i.popup.delay_verify_time || i.popup.delay_verify_remark || i.popup.depart_verify_name || i.popup.depart_verify_time || i.popup.resource_verify_name || i.popup.end_time) && i.tag_msg != '延期成功'" class="tips">
                    <!-- <span></span> -->
                    <div v-if="i.msg_color == 'red' && i.msg != '已逾期，请快速归还' && !i.has_tag" class="tipsBg">
                      <div v-if="i.msg == '延期申请待审核'" class="t">
                        <div class="l">
                          <p class="n">部门审核：</p>
                          <p @click="showCardRight(i.popup.depart_verify_uid, 0, $event)">{{i.popup.depart_verify_name}}</p>
                        </div>
                        <p class="date">{{i.popup.depart_verify_time}}</p>
                      </div>
                      <div v-if="i.msg == '延期申请待审核'" class="e">
                        <p class="n">资源审核：</p>
                        <p @click="showCardRight(i.popup.resource_verify_name, 0, $event)">{{i.popup.resource_verify_name}}</p>
                      </div>
                      <div v-if="i.msg == '延期申请待审核'" class="e">
                        <p class="n">设备到期时间：</p>
                        <p>{{i.popup.end_time}}</p>
                      </div>
                      <div v-if="i.msg != '延期申请待审核'" class="t">
                        <div class="l">
                          <p class="n">延期审核：</p>
                          <p @click="showCardRight(i.popup.delay_verify_uid, 0, $event)">{{i.popup.delay_verify_name}}</p>
                        </div>
                        <p class="date">{{i.popup.delay_verify_time}}</p>
                      </div>
                      <div v-if="i.msg != '延期申请待审核'" class="e">
                        <p class="n">失败原因：</p>
                        <p>{{i.popup.delay_verify_remark}}</p>
                      </div>
                    </div>
                    <div v-else class="tipsBg">
                      <div v-if="i.tag_color == 'red' && i.tag_msg != '延期失败'" class="t">
                        <div class="l">
                          <p class="n">归还审核：</p>
                          <p @click="showCardRight(i.popup.return_verify_uid, 0, $event)">{{i.popup.return_verify_name}}</p>
                        </div>
                        <p class="date">{{i.popup.return_verify_time}}</p>
                      </div>
                      <div v-if="i.tag_color == 'red' && i.tag_msg != '延期失败'" class="e">
                        <p class="n">失败原因：</p>
                        <p>{{i.popup.return_verify_remark}}</p>
                      </div>
                      <div v-if="i.tag_color == 'red' && i.tag_msg == '延期失败'" class="t">
                        <div class="l">
                          <p class="n">延期审核：</p>
                          <p @click="showCardRight(i.popup.delay_verify_uid, 0, $event)">{{i.popup.delay_verify_name}}</p>
                        </div>
                        <p class="date">{{i.popup.delay_verify_time}}</p>
                      </div>
                      <div v-if="i.tag_color == 'red' && i.tag_msg == '延期失败'" class="e">
                        <p class="n">失败原因：</p>
                        <p>{{i.popup.delay_verify_remark}}</p>
                      </div>
                      <!-- <div v-if="i.tag_color != 'red'" class="t">
                        <div class="l">
                          <p class="n">部门审核：</p>
                          <p @click="showCardRight(i.popup.delay_verify_uid, 0, $event)">{{i.popup.depart_verify_name}}</p>
                        </div>
                        <p class="date">{{i.popup.depart_verify_time}}</p>
                      </div>
                      <div v-if="i.tag_color != 'red'" class="e">
                        <p class="n">资源审核：</p>
                        <p @click="showCardRight(i.popup.resource_verify_name, 0, $event)">{{i.popup.resource_verify_name}}</p>
                      </div>
                      <div v-if="i.tag_color != 'red'" class="e">
                        <p class="n">设备到期时间：</p>
                        <p>{{i.popup.end_time}}</p>
                      </div> -->
                    </div>
                  </div>
                  <div class="item-left">{{i.type_title}}</div>
                  <div class="item-right">
                    <div class="row">
                      <div class="equipmentTitle" :title="i.device_name">{{i.device_name}}</div>
                      <div v-if="i.has_tag" :class="{success: i.tag_color != 'red', fail: i.tag_color == 'red'}">{{i.tag_msg}}
                        <!-- <div v-if="(i.popup.return_verify_name || i.popup.return_verify_time || i.popup.return_verify_remark || i.popup.delay_verify_name || i.popup.delay_verify_time || i.popup.delay_verify_remark || i.popup.depart_verify_name || i.popup.depart_verify_time || i.popup.resource_verify_name || i.popup.end_time) && i.tag_msg != '延期成功'" class="tips">
                          <span></span>
                          <div class="tipsBg">
                            <div v-if="i.tag_color == 'red' && i.tag_msg != '延期失败'" class="t">
                              <div class="l">
                                <p class="n">归还审核：</p>
                                <p @click="showCardRight(i.popup.return_verify_uid, 0, $event)">{{i.popup.return_verify_name}}</p>
                              </div>
                              <p class="date">{{i.popup.return_verify_time}}</p>
                            </div>
                            <div v-if="i.tag_color == 'red' && i.tag_msg != '延期失败'" class="e">
                              <p class="n">失败原因：</p>
                              <p>{{i.popup.return_verify_remark}}</p>
                            </div>
                            <div v-if="i.tag_color == 'red' && i.tag_msg == '延期失败'" class="t">
                              <div class="l">
                                <p class="n">延期审核：</p>
                                <p @click="showCardRight(i.popup.delay_verify_uid, 0, $event)">{{i.popup.delay_verify_name}}</p>
                              </div>
                              <p class="date">{{i.popup.delay_verify_time}}</p>
                            </div>
                            <div v-if="i.tag_color == 'red' && i.tag_msg == '延期失败'" class="e">
                              <p class="n">失败原因：</p>
                              <p>{{i.popup.delay_verify_remark}}</p>
                            </div>
                            <div v-if="i.tag_color != 'red'" class="t">
                              <div class="l">
                                <p class="n">部门审核：</p>
                                <p @click="showCardRight(i.popup.delay_verify_uid, 0, $event)">{{i.popup.depart_verify_name}}</p>
                              </div>
                              <p class="date">{{i.popup.depart_verify_time}}</p>
                            </div>
                            <div v-if="i.tag_color != 'red'" class="e">
                              <p class="n">资源审核：</p>
                              <p @click="showCardRight(i.popup.resource_verify_name, 0, $event)">{{i.popup.resource_verify_name}}</p>
                            </div>
                            <div v-if="i.tag_color != 'red'" class="e">
                              <p class="n">设备到期时间：</p>
                              <p>{{i.popup.end_time}}</p>
                            </div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <p v-if="i.msg_color == 'grey'" class="date">{{i.msg}}</p>
                    <p v-if="i.msg_color == 'green'" class="success">{{i.msg}}</p>
                    <div v-if="i.msg_color == 'red'" class="fail">{{i.msg}}
                      <!-- <div v-if="(i.popup.return_verify_name || i.popup.return_verify_time || i.popup.return_verify_remark || i.popup.delay_verify_name || i.popup.delay_verify_time || i.popup.delay_verify_remark || i.popup.depart_verify_name || i.popup.depart_verify_time || i.popup.resource_verify_name || i.popup.end_time) && i.tag_msg != '延期成功' && i.msg != '已逾期，请快速归还'" class="tips">
                          <span></span>
                          <div class="tipsBg">
                            <div v-if="i.msg == '延期申请待审核'" class="t">
                              <div class="l">
                                <p class="n">部门审核：</p>
                                <p @click="showCardRight(i.popup.delay_verify_uid, 0, $event)">{{i.popup.depart_verify_name}}</p>
                              </div>
                              <p class="date">{{i.popup.depart_verify_time}}</p>
                            </div>
                            <div v-if="i.msg == '延期申请待审核'" class="e">
                              <p class="n">资源审核：</p>
                              <p @click="showCardRight(i.popup.resource_verify_name, 0, $event)">{{i.popup.resource_verify_name}}</p>
                            </div>
                            <div v-if="i.msg == '延期申请待审核'" class="e">
                              <p class="n">设备到期时间：</p>
                              <p>{{i.popup.end_time}}</p>
                            </div>
                            <div v-if="i.msg != '延期申请待审核'" class="t">
                              <div class="l">
                                <p class="n">延期审核：</p>
                                <p @click="showCardRight(i.popup.delay_verify_uid, 0, $event)">{{i.popup.delay_verify_name}}</p>
                              </div>
                              <p class="date">{{i.popup.delay_verify_time}}</p>
                            </div>
                            <div v-if="i.msg != '延期申请待审核'" class="e">
                              <p class="n">失败原因：</p>
                              <p>{{i.popup.delay_verify_remark}}</p>
                            </div>
                          </div>
                        </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="btn">
              <p v-if="show_receive" @click="receive" class="get">
                <i></i>
                <span>领取设备</span>
              </p>
              <p v-if="show_delay" @click="delayList" class="delay">
                <i></i>
                <span>延期申请</span>
              </p>
              <p v-if="show_return" @click="returnList" class="set">
                <i></i>
                <span>归还设备</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div :class="{uploads: true,empty: uploads.length==0}">
        <div class="headline">
          <p class="headTitle">
            上传的内容
          </p>
          <div class="new" @click="goClue()" v-if="showUpload">
            <img src="@assets/img/interview/upload.svg" alt="new">
            <span>上传线索</span>
          </div>
        </div>
        <empty :msg="'暂无内容'" v-if="uploads.length === 0" />
        <div class="items" v-for="(report, reportIndex) in uploads" :key="reportIndex">
          <div class="item">
            <div class="pic">
              <img class="main" :src="report.cover || defaultImg" alt="pic" v-if="report.img">
              <img v-if="report.video && report.img" class="play" src="@assets/img/index/play.svg" alt="play">
              <img class="main" src="@assets/img/common/default.png" alt="default" v-if="!report.img">
            </div>
            <div class="article">
              <div class="title" @click="goClueDetail(report)">
                <p class="words">
                  {{report.title}}
                </p>
              </div>
              <p class="content">
                {{report.content}}
              </p>
              <div class="footline">
                <p class="mark">
                  <img src="@assets/img/index/time.svg" alt="time">
                  <span>{{report.release_time}}</span>
                </p>
                <p class="mark">
                  <img src="@assets/img/interview/reporter-l.svg" alt="reporter">
                  <span>{{report.username}}</span>
                </p>
              </div>
            </div>
            <div class="handles" :style="{visibility: 'hidden'}">
              <div class="handle">
                删除
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" :style="{width: `calc(100vw - ${footLineGap}px)`}">
      <div class="pop" v-show="showHistory">
        <p class="progress" :style="{height: `${progressH}px`}"></p>
        <div class="stages">
          <div :class="{item: true, on: i === 0}" v-for="(h, i) in interviewHistory" :key="i">
            <p class="name">
              {{h.action}}
            </p>
            <div class="info">
              <span class="time">{{h.raw_add_time}}</span>
              <span class="normal uname">{{h.opt_username}}</span>
              <span :class="{normal: true, pass: h.action_color == 1, abort: h.action_color == 2}">{{h.type}}</span>
              <!-- <span class="normal">{{''}}</span> -->
            </div>
          </div>
        </div>
      </div>
      <div :class="{btn: true, life: true, disable: !showHistory}" @click="toggleHistory()">
        {{`${$_syscfg.interview}的一生`}}
      </div>
      <div v-if="isCheck" class="btn disable" @click="goEdit()">编辑</div>
      <div v-if="isCheck" class="btn prov" @click="handleInterviews(0)">通过</div>
      <div v-if="isCheck" class="btn disable" @click="handleInterviews(1)">退回</div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import { apis } from '@common/config'
import empty from '@components/empty'
import dc from '@common/dc'

export default {
  name: 'interviewDetail',
  components: {
    empty
  },
  data() {
    return {
      show_receive: false,
      show_delay: false,
      show_return: false,
      expandDevice: [],
      statusNum: '',
      expand_device_task_status: '',
      back_reason: '',
      isXnew: this.$store.state.isXnew,
      title: '',
      status: '',
      dep: '',
      topic: '',
      topicId: '',
      startTime: '',
      endTime: '',
      locate: '',
      reporter: '',
      camera: '',
      driver: '',
      bus: '',
      remark: '',
      publisher: '',
      approver: '',
      handler: '',
      publisherId: '',
      approverId: '',
      handlerId: '',
      expandhandler: '',
      expandhandlerId: '',
      equipments: [],
      uploads: [],
      defaultImg: require('@assets/img/common/default.png'),
      showHistory: false,
      interviewHistory: [],
      showUpload: false,
      topicDeleted: false,
      isCheck: false, // 是否是审核详情页
      hasClueRole: false,
      topicRole: false, // 是否有策划详情权限
      progressH: 0,
      footLineGap: 230,
      showTopic: false,
      set_device_outdate_alarm: 0,
      is_received: 0
    }
  },
  methods: {
    equipDetail(i) {
      console.log(i)
      this.$equipInfo(i)
    },
    tipsout() {
      let cardRight = document.getElementsByClassName('cardRight')[0]
      if(cardRight){
        cardRight.remove()
      }
      // console.log(999)
    },
    receive() {
      this.$InterviewCheck({
        title: '领取设备',
        type: 'noSelect',
        mode: 'get',
        id: this.$route.query.r,
        expandDevice: this.expandDevice,
        set_device_outdate_alarm: this.set_device_outdate_alarm
      }).then(res => {
        if(res){
          this.getDetail()
        }
      })
    },
    delayList() {
      const data = {
          iview_id: this.$route.query.r
      }

      common.myFetch(apis.Delaylist, data)
          .then((data) => {
            console.log(data)
            data.list.forEach(el => {
              el.content = '',
              el.date = '',
              el.selected = false
            });
            this.$InterviewCheck({
              title: '请选择需要延期归还的设备',
              type: 'select',
              mode: 'delay',
              id: this.$route.query.r,
              expandDevice: data.list
            }).then(res => {
              if(res){
                this.getDetail()
              }
            })
      })
    },
    returnList() {
      const data = {
          iview_id: this.$route.query.r
      }

      common.myFetch(apis.Return_list, data)
          .then((data) => {
            console.log(data)
            data.list.forEach(el => {
              el.content = '',
              el.url = ''
              el.name = ''
              el.uploadId = ''
              el.isUpload = false
              el.progress = true
              el.progressNum = 0
              el.selected = true
            });
            this.$InterviewCheck({
              title: '请选择需要归还的设备',
              type: 'select',
              mode: 'back',
              id: this.$route.query.r,
              expandDevice: data.list
            }).then(res => {
              if(res){
                this.getDetail()
              }
            })
          // this.$toast(data)
          // this.show = false;
          // this.callback(true)
          // console.log(data)
      })
      
    },
    showCard(id, type, e) {
      if (id == 0) return
      type = type || 0

      const el = e.target

      this.$card(id, el, type)
    },
    showCardRight(id, type, e) {
      // console.log(123)
      if (id == 0) return;
// console.log(123)
      const el = e.target;

      this.$cardRight(id, el, type);
    },
    goClueDetail(r) {
      if (!this.hasClueRole) {
        this.$toast('无访问权限')
        return
      }

      common.jump(`/clueDetail?d=${r.material_id}`, true)
    },
    toggleHistory() {
      this.showHistory = !this.showHistory

      if (this.showHistory) {
        this.$nextTick(() => {
          const container = document.querySelector('.stages')
          const stagesHeight = container.scrollHeight
          this.progressH = stagesHeight
        })
      }
    },
    checkType() {
      // 检查页面类型：详情 ／ 审核详情
      const c = this.$route.query.c
      if (c) {
        this.isCheck = true
      }
    },
    async goEdit() {
      const id = this.$route.query.r
      const checked = await common.checkPageStatus(id, 0)
      if (!checked) return

      this.$router.push({
        path: '/editInterview',
        query: {
          r: id
        }
      })
    },
    async handleInterviews(status) {
      let msg = '确认通过吗？'
      if (status === 1) {
        msg = '确认退回吗？'
      }
      const c = await this.$confirm(msg)
      if (!c) return

      const id = this.$route.query.r
      const info = {
        iview_id: id,
        status: status
      }

      common.myFetch(apis.Itv_handle_interviews, info)
        .then((data) => {
          if (data) {
            this.$toast(data)

            // window.history.go(-1)
            this.$router.push({
              path: '/checkInterviews'
            })
          }
        })
    },
    getDetail() {
      // 获取详情数据
      const id = this.$route.query.r
      const data = {
        iview_id: id
      }

      common.myFetch(apis.Itv_interview_detail, data)
        .then((data) => {
          this.matchData(data.detail)
          this.show_receive = data.show_receive
          this.show_delay = data.show_delay
          this.show_return = data.show_return
          this.expandDevice = data.expandDevice
          this.showTopic = !!data.topicExist
          this.set_device_outdate_alarm = data.set_device_outdate_alarm
          this.is_received = data.is_received
        })
    },
    getClues() {
      // 获取关联线索
      const info = {
        iview_id: this.$route.query.r
      }

      common.myFetch(apis.Itv_clues, info)
        .then((r) => {
          if (r) {
            this.uploads = r.list
            this.hasClueRole = r.has_material_role
          }
        })
    },
    getHistory() {
      // 获取采访的一生
      const id = this.$route.query.r
      const data = {
        iview_id: id
      }

      common.myFetch(apis.Itv_interview_history, data, 'post')
        .then((data) => {
          this.interviewHistory = data.list
        })
    },
    matchData(data) {
      // 处理详情数据，展示到页面
      this.title = data.iview_title
      this.dep = data.depart_name
      this.topic = data.topic_title
      this.topicId = data.topic_id
      this.startTime = data.start
      this.endTime = data.end
      this.locate = data.address
      this.reporter = data.base_class.reporters
      this.camera = data.base_class.cameras
      this.driver = data.base_class.drivers
      this.bus = data.base_class.cars.map(i => { return i.name }).join(',')
      this.remark = data.remark
      this.publisher = data.user_name
      this.approver = data.verify_name
      this.handler = data.resource_name
      this.publisherId = data.user_id
      this.approverId = data.verify_uid
      this.handlerId = data.resource_uid
      this.expandhandler = data.expand_username
      this.expandhandlerId = data.expand_uid
      this.equipments = data.sub_class
      this.statusNum = data.status
      this.expand_device_task_status = data.expand_device_task_status
      this.back_reason = data.back_reason
      this.status = data.status_name
      this.showUpload = (data.status == 2 || data.status == 3) && data.has_material_role
      this.topicDeleted = data.topic_is_delete == 1
      this.topicRole = data.has_topic_detail_role
    },
    goTopic(i) {
      if (this.topicDeleted || !this.topicRole) return

      this.$router.push({
        path: '/topicDetail',
        query: {
          d: i
        }
      })
    },
    goClue() {
      // 去创建线索页
      const d = {
        id: this.$route.query.r,
        title: this.title
      }

      dc.setItv(d)

      setTimeout(() => {
        dc.delItv()
      }, 0)

      common.jump('/creatClue', true)
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    this.checkType()
    this.getDetail()
    this.getClues()
    this.getHistory()
  },
  created() {
    common.goTop()
  }
}
</script>

<style lang="less" src="@assets/css/interview/interviewDetail.less" scoped></style>
